import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ModalLayout from '../ModalLayout';
import ModalBodyLayout from '../ModalBodyLayout';
import { Typography } from '../../../components';
import { handleUserEnvironmentUrl } from '../../../utilities/helpers';
import { ACCOUNT_REGIONS } from '../../../utilities/constants';
import {
  cacheUserEnvironment,
  cacheUserWantsToStayInInternationalApp,
  cacheUserWantsToStayInUSApp,
} from '../../../utilities/caching';
import useUserIPLocation from '../../../utilities/sharedHooks/useUserIPLocation';

const UsAppWarningModal = ({ isVisible, toggle }) => {
  const { t: translate } = useTranslation();
  const { isUSA: isUSAIpAddress } = useUserIPLocation();

  const internationalUserVisitUSApp = useMemo(
    () => !isUSAIpAddress && window.location.hostname === process.env.REACT_APP_US_FE_BASE_HOSTNAME,
    [isUSAIpAddress]
  );

  const renderFooter = () => (
    <div className="d-flex flex-column w-100 px-0" style={{ gap: '1.5rem' }}>
      <button
        type="button"
        className="btn btn-primary py-3 w-100"
        onClick={() => {
          if (internationalUserVisitUSApp) {
            handleUserEnvironmentUrl('promo', true);
          } else {
            cacheUserEnvironment(ACCOUNT_REGIONS.US);
            handleUserEnvironmentUrl('promo');
          }
        }}>
        {internationalUserVisitUSApp
          ? translate('us_app_warning_btn_label')
          : translate('eu_app_warning_btn_label')}
      </button>
      <button
        type="button"
        className="btn border border-disabled py-3 w-100 text-btn-item"
        onClick={() => {
          if (internationalUserVisitUSApp) {
            cacheUserWantsToStayInUSApp();
          } else {
            cacheUserWantsToStayInInternationalApp();
          }
          toggle();
        }}>
        {translate('us_app_warning_skip_btn_label')}
      </button>
    </div>
  );

  return (
    <ModalLayout
      modalContentStyle={{
        maxHeight: '28rem',
      }}
      onHide={toggle}
      isVisible={isVisible}
      currentScreen="usAppWarning">
      <ModalBodyLayout
        keyName="usAppWarning"
        withBack={false}
        title={
          internationalUserVisitUSApp
            ? translate('us_app_warning_title')
            : translate('eu_app_warning_title')
        }
        isButtonInFooter
        renderFooter={renderFooter}
        isScrollable>
        <div
          className="d-flex flex-column align-items-center justify-content-between"
          style={{ paddingTop: '1.5rem' }}>
          <Typography as="p" className="text-white">
            {internationalUserVisitUSApp
              ? translate('us_app_warning_note')
              : translate('eu_app_warning_note')}
          </Typography>
        </div>
      </ModalBodyLayout>
    </ModalLayout>
  );
};

export default UsAppWarningModal;

UsAppWarningModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};
